<template>
  <div>
    <table
      :height="this.windowSize.height - 8"
      :max-height="this.windowSize.height - 8"
      style="position: absolute"
      width="100%"
    >
      <tr height="48px" max-height="48px">
        <ContenidoBase
          :EstadoBtn="EstadoBtn"
          :descripcion="'Imprime todas las facturas por cliente entre rango de fecha y por tipo de cliente.'"
          :titulo="'Reporte Facturas por Vendedores y Clientes'"
          @MethodAnular="anular"
          @MethodEliminar="remove"
          @MethodGuardar="save"
          @MethodImprimir="imprimirList"
          @MethodNuevo="newwnuevo"
          @abrirBarraTablaDinamica="abrirTabla"
        />
      </tr>

      <tr>
        <!-- BarraPrimaria --------------------------------------------------------------------------------->
        <td v-show="BarraTablaDinamicaAprir" :max-height="this.windowSize.height - 96" width="109">
          <div
            class="overflow-y-auto"
            v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px', 'max-width': '325px', width: '325px' }"
          >
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <center>
                  <v-btn-toggle>
                    <v-btn color="yellow accent-4" small @click.prevent="actualiza_tb_ver">
                      <i class="fa fa-eye" style="font-size: 25px"></i>
                      ver
                    </v-btn>
                    <v-btn
                      color="deep-purple accent-2"
                      dark
                      small
                      @click.prevent="notifi('Seguro que desea nuevo', 'n')"
                    >
                      <i class="fa fa-print" style="font-size: 25px"></i>
                      Listado
                    </v-btn>
                  </v-btn-toggle>
                </center>
                <!-- <BarraBusqueda2
                  :url="
                    $hostname + $hName + '/services/tipocliente/findalltipoclientes'
                  "
                  :nombre="'Tipo de Clientes'"
                  :headers="headers"
                  :slotname="'item.descripcion'"
                  :emitnombre="'emitReporteFacturaClientes'"
                  :SeachNombre="'Búsqueda por descripcion '"
                  :slotlist="slotlist"
                /> -->
              </template>
            </v-tooltip>
          </div>
        </td>
        <!-- fn BarraPrimaria ---------------------------------------------------------------------------------->
        <!-- contenido central ------------------------------------------------------------------------------ -->
        <td :max-height="this.windowSize.height - 96">
          <v-app
            id="inspire"
            class="overflow-y-auto"
            v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px' }"
          >
            <!-- Formulario-Facturas por Vendedores y Clientes-->
            <v-container>
              <v-card color="grey lighten-3">
                <v-toolbar color="#BDBDBD" dense flat style="border: 1px solid #000000">
                  <v-avatar size="45" tile>
                    <img alt="Reporte" src="@/assets/iconos_micromarket/custom-reports.png" />
                  </v-avatar>

                  <span class="font-weight-light" style="font-size: 20px">
                    Reporte Facturas por Vendedores y Clientes
                  </span>

                  <!-- <v-toolbar-title    class="font-weight-light"> Reporte Producción de boletos por unidades</v-toolbar-title > -->
                  <!-- style="color:white;" -->
                  <!-- <i class=""> </i> -->

                  <!-- <v-spacer></v-spacer> -->
                  <!-- <v-btn
                    color="grey darken-4"
                    fab
                    small
                    @click="cerrarmodalcuenta"
                  >
                   <i  style="font-size: 20px; color:white;" class="fa fa-close"></i>
                  </v-btn> -->
                </v-toolbar>

                <hr />

                <v-container style="border: 1px solid #000000">
                  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="">
                    <v-row>
                      <!-- columna 1 -->
                      <v-col cols="12" md="6" sm="6">
                        <!-- -----------------------------  desde  -->
                        <v-text-field
                          v-model="FacturaClientes.desde"
                          :rules="[$rules.required]"
                          dense
                          label="Desde:"
                          outlined
                          type="date"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-calendar" style="font-size: 20px"></i>
                          </template>
                        </v-text-field>

                        <!-- ----------------------------- Tipo de Cliente -->
                        <v-combobox
                          v-model="FacturaClientes.tipocliente"
                          :items="RtipoCliente"
                          :rules="[$rules.required]"
                          autocomplete="off"
                          dense
                          item-text="descripcion"
                          label="Tipo de Cliente:"
                          outlined
                          @blur="SelctCbTipoCliente"
                          @focus="cargarTipoCliente"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-users" style="font-size: 20px"></i>
                          </template>
                        </v-combobox>

                        <!-- ----------------------------- Tipo de Cliente -->
                        <v-combobox
                          v-model="FacturaClientes.ZonaCliente"
                          :items="RZonaCliente"
                          autocomplete="off"
                          dense
                          item-text="descripcion"
                          label="Zonas de Clientes:"
                          outlined
                          @blur="SelctCbZonaCliente"
                          @focus="cargarZonaCliente"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-map-pin" style="font-size: 20px; width: 1.3rem"></i>
                          </template>
                        </v-combobox>
                      </v-col>
                      <!-- fn columna 1 -->

                      <!-- columna 2 -->
                      <v-col cols="12" md="6" sm="6">
                        <!-- -----------------------------  Hasta  -->
                        <v-text-field
                          v-model="FacturaClientes.hasta"
                          :rules="[$rules.required]"
                          dense
                          label="Hasta:"
                          outlined
                          type="date"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-calendar" style="font-size: 20px"></i>
                          </template>
                        </v-text-field>

                        <!--- Subtipo de Cliente --->
                        <v-autocomplete
                          v-model="FacturaClientes.subtipoCliente"
                          :items="
                            FacturaClientes.tipocliente
                              ? FacturaClientes.tipocliente.subtipos
                              : FacturaClientes.subtipo || []
                          "
                          clearable
                          dense
                          item-text="descripcion"
                          label="Subtipo de Cliente:"
                          outlined
                          return-object
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-user-plus" style="font-size: 20px; width: 1.3rem"></i>
                          </template>
                        </v-autocomplete>

                        <v-combobox
                          v-model="FacturaClientes.vendedor"
                          :items="Rvendedor"
                          autocomplete="off"
                          dense
                          item-text="nombre"
                          label=" Vendedor:"
                          outlined
                          required
                          style="font-size: 13px"
                          @blur="SelctCbvendedor"
                          @focus="CargarRvendedor"
                        >
                          <template slot="item" slot-scope="item">
                            <!--<v-col cols="12" md="12" sm="12"> <v-row no-gutters></v-row> </v-col>-->
                            <v-col
                              class="pa-0 ma-0 py-0 my-0"
                              cols="12"
                              md="12"
                              sm="12"
                              style="border: 1px solid #000000; font-size: 13px"
                            >
                              <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed #616161">
                                <b>Descripción: {{ item.item.nombre }}</b>
                              </p>
                              <span class="pa-0 ma-0 py-0 my-0">
                                <span class="pe-1" style="border: 1px dashed #616161">
                                  <b>Cedula.:</b>
                                  {{ item.item.cedula }}
                                </span>
                                <span class="pe-1" style="border: 1px dashed #616161">
                                  <b>Telefono:</b>
                                  {{ item.item.telefono }}
                                </span>
                                <!-- <span class="pe-1" style="border: 1px dashed  #616161;"><b>Placa: </b> {{item.item.placa }} </span> -->
                              </span>
                            </v-col>
                          </template>

                          <template v-slot:prepend>
                            <i class="fa fa-universal-access" style="font-size: 20px"></i>
                          </template>
                        </v-combobox>

                        <v-switch
                          v-model="FacturaClientes.Resumen"
                          class="mt-0"
                          color="teal"
                          hide-details
                          inset
                          label="Reporte Resumido:"
                        >
                          <template v-slot:label>
                            <strong style="color: #000000">
                              Reporte Resumido: {{ FacturaClientes.Resumen ? "Si" : "No" }}
                            </strong>
                          </template>
                        </v-switch>

                        <v-switch
                          v-model="FacturaClientes.showNotaCredito"
                          class="mt-2"
                          color="teal"
                          hide-details
                          inset
                          label="Reporte Resumido:"
                        >
                          <template v-slot:label>
                            <strong style="color: #000000">
                              Mostrar Notas de Credito: {{ FacturaClientes.showNotaCredito ? "Si" : "No" }}
                            </strong>
                          </template>
                        </v-switch>
                      </v-col>
                      <!-- fn columna 2 -->
                    </v-row>
                  </v-form>
                </v-container>

                <hr />

                <ModalReporteFiltros :Datos="FacturaClientes" @DataReporteBasico="DDataReporteBasico" />
              </v-card>
            </v-container>
            <!-- fn Formulario-Facturas por Vendedores y Clientes-->
          </v-app>
        </td>
        <!-- fn contenido central ------------------------------------------------------------------------------------->
        <!-- BarraSecundaria ------------------------------------------------------------------------------------------>
        <td v-show="BarraSecundariaAprir" :max-height="this.windowSize.height - 96" width="109">
          <div
            class="overflow-y-auto"
            v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px', 'max-width': '325px', width: '325px' }"
          >
            <!--
                    <BarraBusqueda2
                          :url="$hostname + $hName + '/services/caja/findAll'"
                          :nombre="'Cajas'"
                          :headers="headers"
                          :slotname="'item.descripcion'"
                          :emitnombre="'emitCaja'"
                          :slotlist="slotlist"
                          :SeachNombre="'Búsqueda por descripción caja'"
                        /> -->
          </div>
        </td>
        <!-- fn BarraSecundaria --------------------------------------------------------------------------------------->
      </tr>
    </table>
    <!-- Modales -------------------------------------------------------------------------------------------------->
    <!-- ------------------------------------------------------ tb-data-->
    <v-dialog
      v-model="acti_tb_data"
      label="myAlert"
      max-height="100%"
      max-width="100%"
      persistent
      transition="fab-transition"
    >
      <v-card>
        <v-toolbar color="#BDBDBD" flat>
          <i class="fa fa-file-pdf-o" style="font-size: 20px"></i>
          <v-toolbar-title class="font-weight-light">REPORTE</v-toolbar-title>
          <i class="fa fa-file-pdf-o" style="font-size: 20px"></i>

          <v-spacer></v-spacer>
          <v-btn color="grey darken-4" fab small @click="acti_tb_data = !acti_tb_data">
            <i class="fa fa-close" style="font-size: 20px; color: #dd4b39"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field v-model="search" hide-details label="Buscar" single-line @keyup="filtro">
                <template v-slot:prepend-inner>
                  <i class="fa fa-search" style="font-size: 35px"></i>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table :headers="slotHtabla" :items="list" :search="search" dense @click:row="datostabla">
              <template v-slot:item.porciento="props">
                <span>{{ currencyFormatter(props.item.porciento) }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!------------otras funciones---------------->
    <v-snackbar
      v-model="aalert.estado"
      :color="aalert.color"
      :timeout="120000"
      :vertical="true"
      style="margin-top: 20%"
      top="top"
    >
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

    <!-- fn Modales ----------------------------------------------------------------------------------------------->
  </div>
</template>

<script>
  import { EventBus } from "../../event-bus"
  import BarraBusqueda2 from "../../components/BarraBusquedaDinam"
  import ContenidoBase from "../../components/ContenidoBase"
  import ModalReporteFiltros from "../../components/ModalReporteFiltros"
  import {
    currencyFormatter,
    fechaNueva,
    FormatoFecha,
    getParamFecha,
    HoraFormatter,
    HoraFormatter2,
    RedondeoBasico,
    RedondeoValor,
    RedondeoValorCantRed,
  } from "@/js/Funciones.js"

  export default {
    components: {
      BarraBusqueda2,
      ContenidoBase,
      ModalReporteFiltros,
    },
    created() {
      var json = {
        titulo: "Reporte Factura por Clientes",
        descripcion: "Imprime todas las facturas por cliente entre rango de fecha y por tipo de cliente.",
        save: false,
        eliminar: false,
        anular: false,
        nuevo: false,
        imprimir: false,
        accion: [
          "ReporteFacturaClientesNew",
          "ReporteFacturaClientesSave",
          "ReporteFacturaClientesRemove",
          "ReporteFacturaClientesAnular",
          "ReporteFacturaClientesPrintList",
        ],
      }
      EventBus.$emit("anularBotonesAccion", json)
    },
    mounted() {
      EventBus.$on("abrirMenuizquierdo", this.abrirTabla)
      // EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
      EventBus.$on("ReporteFacturaClientesNew", this.new)
      EventBus.$on("ReporteFacturaClientesSave", this.save)
      EventBus.$on("ReporteFacturaClientesRemove", this.remove)
      EventBus.$on("ReporteFacturaClientesAnular", this.remove)
      EventBus.$on("ReporteFacturaClientesPrintList", this.imprimirList)
      EventBus.$on("emitReporteFacturaClientes", this.datostabla)
      EventBus.$on("onResize", this.onResize)
    },

    data: () => ({
      RtipoCliente: [],
      Rcliente: [],
      Rvendedor: [],
      RZonaCliente: [],

      windowSize: { width: "auto", height: "auto" },

      FacturaClientes: {
        nombre: "Facturas por Vendedores y Clientes",
        UrlImprimir: "/reportescxc/ImprimirFacturasVenCli",
        UrlExel: "/reportescxc/ExcelFacturasVenCli",
        UrlCorreo: "/reportescxc/CorreoFacturasVenCli",

        desde: fechaNueva(),
        hasta: fechaNueva(),
        Resumen: true,
        tipocliente: null,
        subtipoCliente: null,
        vendedor: null,
        ZonaCliente: null,
        showNotaCredito: false,

        //fechaCreacion: new,
        //  fechaModificacion: "",
      },
      EstadoBtn: {
        BarraTablaDinamicaAprir: false,
        nuevo: false,
        guardar: false,
        eliminar: false,
        anular: false,
        imprimir: false,
        vercuenta: false,
        guardartemporal: false,
        restaurartemporal: false,
        importarDato: false,
        cargarProducto: false,
        ImprimirproductoInv: false,
      },

      text: "",
      valid: true,
      BarraTablaDinamicaAprir: false,
      BarraSecundariaAprir: false,

      headers: [{ text: "Tipo Clientes", value: "descripcion" }],

      slotlist: [
        { dt0: "codigo", dt1: null, dt2: null, dt3: 1, dt4: "Código:" },
        {
          dt0: "descripcion",
          dt1: null,
          dt2: null,
          dt3: 1,
          dt4: "Descripcion:",
        },
        { dt0: "activo", dt1: null, dt2: null, dt3: 0.1, dt4: "Desactivo" },
      ],

      slotHtabla: [
        { text: "Código", value: "codigo" },
        { text: "Descripcion", value: "descripcion" },
      ],

      list: [],
      search: "",
      acti_tb_data: false,

      aalert: {
        estado: false,
        color: null,
      },
    }),

    //   destroyed() {
    //     location.reload();
    //   },
    methods: {
      currencyFormatter,
      FormatoFecha,
      HoraFormatter,
      HoraFormatter2,
      RedondeoValor,
      RedondeoBasico,
      RedondeoValorCantRed,
      fechaNueva,
      getParamFecha,

      onResize(e) {
        console.log("imprii ")

        console.log(e)
        this.windowSize = e
      },

      abrirTabla() {
        this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir
      },

      datostabla(e) {
        this.FacturaClientes = e
        this.acti_tb_data = false
      },
      save() {},
      remove() {},
      eliminar() {},
      anular() {},
      imprimirList() {},
      // Retorna los datos del componente ModalReporteFiltros
      DDataReporteBasico() {},
      newwnuevo() {
        ;(this.FacturaClientes = {
          activo: true,
          borrado: false,
          codigo: 0,
          descripcion: "",
          descripcionOriginal: "",
          fechaCreacion: "",
          fechaModificacion: "",
          usuarioCreacion: "",
          usuarioModificacion: "",
        }),
          EventBus.$emit("actualizaBarraBusqueda2")
      },

      // Llamar a una API y obtener los datos de la API y almacenarlos en la variable RtipoCliente.
      cargarTipoCliente() {
        this.$axios
          .get(this.$hostname + this.$hName + "/tipoclientes/findall", { headers: this.$store.getters.GetheadersAxios })
          .then((res) => (this.RtipoCliente = res.data))
      },

      // Comprobando si el valor de la selección es nulo o indefinido.
      SelctCbTipoCliente() {
        if (this.FacturaClientes.tipocliente == null) {
          this.FacturaClientes.tipocliente = ""
        }

        if (this.FacturaClientes.tipocliente.codigo == undefined) {
          //this.alerta("Seleccione un tipo de cliente", "error");
          this.FacturaClientes.tipocliente = ""
          return
        }
      },

      // Llamar a la API y obtener los datos de la API y almacenarlos en la variable Rvendedor.
      CargarRvendedor() {
        this.$axios
          .get(this.$hostname + this.$hName + "/vendedores/findallactiv", {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            this.Rvendedor = res.data
          })
      },

      // Comprobando si el valor de la propiedad del vendedor es nulo o indefinido. Si es así, establece el
      // valor en una cadena vacía.
      SelctCbvendedor() {
        if (this.FacturaClientes.vendedor == null) {
          this.FacturaClientes.vendedor = ""
        }

        if (this.FacturaClientes.vendedor.codigo == undefined) {
          //  this.alerta("Seleccione un vendedor", "error");
          this.FacturaClientes.vendedor = ""
          return
        }
      },

      // Hacer una llamada al backend para obtener los datos de la base de datos.
      cargarZonaCliente() {
        this.$axios
          .get(this.$hostname + this.$hName + "/zona/findallactivo", { headers: this.$store.getters.GetheadersAxios })
          .then((res) => {
            this.RZonaCliente = res.data
          })
      },

      // Comprobando si el valor de la selección es nulo o indefinido.
      SelctCbZonaCliente() {
        if (this.FacturaClientes.ZonaCliente == null) {
          this.FacturaClientes.ZonaCliente = ""
        }

        if (this.FacturaClientes.ZonaCliente.codigo == undefined) {
          //  this.alerta("Seleccione una ZonaCliente", "error");
          this.FacturaClientes.ZonaCliente = ""
          return
        }
      },

      alerta(e, l) {
        if (l == "bien") {
          ;(this.aalert.estado = true), (this.aalert.color = "success"), (this.aalert.nombre = e)

          this.newwnuevo()
        }

        if (l == "error") {
          ;(this.aalert.estado = true), (this.aalert.color = "error"), (this.aalert.nombre = e)

          this.ejecucion = false
        }
      },

      actualiza_tb_ver() {
        this.acti_tb_data = !this.acti_tb_data
        this.filtro()
      },

      async filtro() {},
    },
  }
</script>

<style></style>
